/**
 * About-page credentials & coverage copy.
 * Sources and remaining unknowns: docs/trust-placeholders.md.
 */

export const credentialsSections = {
  eyebrow: "Credentials & coverage",
  title: "Licensing, insurance and manufacturer programs",
  body: "Homeowners should be able to verify how a roofing contractor is set up before work starts. The items below describe Revolin Roofing’s coverage and team posture using confirmed figures where available.",
  licensing: {
    title: "Licensing & registration",
    items: [
      "Business registration and operating identity: Revolin Roofing, a Revolin Group company. Operating as Revolin Roofing from 2025.",
      "Crew: a team of 30 licensed contractors with over 10 years of field experience (team experience - not years the roofing division has been in business).",
      "WorkSafeBC registered - clearance letter available on request.",
    ],
  },
  insurance: {
    title: "Insurance",
    items: [
      "Commercial general liability: $10 million. Certificate of insurance available on request.",
      "For homeowners: general liability insurance is the contractor’s coverage for third-party bodily injury and property damage arising from the contractor’s work, subject to policy terms. It is separate from your home insurance and from manufacturer or workmanship warranties.",
    ],
  },
  certifications: {
    title: "Manufacturer certifications & associations",
    items: [
      "Manufacturer-certified installations for the brands we install. Specific dealer or installer program names are confirmed per product system when a project qualifies for enhanced material warranty registration.",
      "RCABC membership / RoofStar pathway is not claimed as a current Revolin Roofing credential. Assemblies follow applicable RCABC guidance and BC requirements where they apply to the work.",
    ],
  },
} as const;
